import {
  createEffect,
  JSXElement,
  Match,
  mergeProps,
  Show,
  Switch
} from 'solid-js';
import styles from '~/components/Layout/Header/header.module.scss';
import { shouldShowBillingBanner } from '~/pages/Billing/utils.ts';
import { shouldShowInProductBanner } from '~/components/Layout/Header/utils.ts';
import { useAppData } from '~/components/AppData';
import InProductBillingBanner from '~/pages/Billing/InProductBillingBanner.tsx';

type WorkspaceInProductBannerPropsType = {
  class?: string;
};

export default function WorkspaceInProductBanner(
  props: WorkspaceInProductBannerPropsType
): JSXElement {
  const merged = mergeProps(
    {
      class: ``
    },
    props
  );

  const appData = useAppData();
  const workspace = appData.workspace;
  const environment = appData.selectedEnvironment;

  if (!workspace || !environment) {
    return <></>;
  }

  createEffect(() => {
    if (
      shouldShowInProductBanner({
        workspace,
        environment
      })
    ) {
      document.documentElement.style.setProperty(
        '--in-product-banner-height',
        '48px'
      );
    } else {
      document.documentElement.style.setProperty(
        '--in-product-banner-height',
        '0px'
      );
    }
  });

  return (
    <Show
      when={shouldShowInProductBanner({
        workspace,
        environment
      })}
    >
      <div class={`${styles.inProductBanner} ${merged.class}`}>
        <Switch>
          <Match
            when={shouldShowBillingBanner({
              workspace,
              environment
            })}
          >
            <InProductBillingBanner />
          </Match>
        </Switch>
      </div>
    </Show>
  );
}
